<template>
  <a
    :class="(page == value ? 'active' : '')+ (disabled? ' disabled' :'')"
    href="javascript:void(0);"
    @click="() => toPageEvent()"
  >
    {{ value }}
  </a>
</template>
<script>
export default {
  name: "PageTag",
  props: {
    value: Number,
    page: Number,
    disabled: Boolean,
  },
  emits: ["toPageEvent"],
  setup: (props, { emit }) => {
    function toPageEvent() {
      emit("toPageEvent");
    }
    return { toPageEvent };
  },
};
</script>
<style scoped>
a {
  margin-inline: 1px;
  display: inline-block;
  padding: 5px 15px;
  border-radius: 50px; /* Make it circular */
  background-color: #ccc; /* Default background color */
  color: #333; /* Text color */
  text-decoration: none;
  transition: background-color 0.3s ease; /* Smooth transition for background color */
}

a:hover {
  background-color: #ddd; /* Background color when hovering */
}

a.active {
  background-color: #007bff; /* Background color when active (clicked) */
  color: #fff; /* Text color when active */
}
a.disabled {
  pointer-events: none;
  background-color: #ddd; /* Background color when hovering */
}
</style>
